import { render, staticRenderFns } from "./MoveBasketDropDown.vue?vue&type=template&id=fbac20a2&scoped=true&"
import script from "./MoveBasketDropDown.vue?vue&type=script&lang=js&"
export * from "./MoveBasketDropDown.vue?vue&type=script&lang=js&"
import style0 from "./MoveBasketDropDown.vue?vue&type=style&index=0&id=fbac20a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbac20a2",
  null
  
)

export default component.exports